import React, { useState, ReactNode, useEffect } from 'react'
import { Box, IconButton } from '@mui/material'
import { styled } from '@mui/system'
import { ArrowEngIcon } from './Svgs'

interface ArrowIconProps {
  rotate: string
  outlined?: boolean
  color?: string
}

interface NestedContentProps {
  title: JSX.Element
  titlePadding?: string
  children: ReactNode
  onOpen?: () => void
  onClose?: () => void
  arrowOutlined?: boolean
  arrowColor: string
  arrowOpenColor?: string
  backgroundColor?: string
  openBackgroundColor?: string
  maxHeight?: string
}

const ArrowIcon = styled(Box)<ArrowIconProps>(
  ({ rotate, outlined, color }) => ({
    transition: 'transform 0.3s ease, color 0.3s ease',
    transform: rotate,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: color || '#04002E',
  }),
)

const NestedContentComponent: React.FC<NestedContentProps> = ({
  title,
  titlePadding,
  children,
  onOpen,
  onClose,
  arrowOutlined,
  arrowColor,
  arrowOpenColor,
  backgroundColor,
  openBackgroundColor,
  maxHeight,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleArrowClick = () => {
    if (isOpen && onOpen) {
      onOpen()
    }
    if (!isOpen && onClose) {
      onClose()
    }

    setIsOpen(!isOpen)
  }

  useEffect(() => {
    return () => {
      setIsOpen(false)
    }
  }, [])

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        p={titlePadding}
      >
        {title}
        <IconButton
          disableRipple
          onClick={handleArrowClick}
          sx={{
            padding: '0',
            fontSize: '1rem',
            border: arrowOutlined ? `1px solid ${arrowColor}` : 'none',
            borderRadius: '0.2rem',
            backgroundColor: isOpen ? openBackgroundColor : backgroundColor,
            width: '1.5rem',
            height: '1.5rem',
          }}
        >
          <ArrowIcon
            rotate={isOpen ? 'rotate(90deg)' : 'rotate(0deg)'}
            outlined={arrowOutlined}
            color={isOpen ? arrowOpenColor : arrowColor}
          >
            <ArrowEngIcon
              color={
                isOpen
                  ? arrowOpenColor
                    ? arrowOpenColor
                    : arrowColor
                  : arrowColor
              }
            />
          </ArrowIcon>
        </IconButton>
      </Box>
      {isOpen && (
        <Box
          mt={'0.75rem'}
          sx={{
            maxHeight: maxHeight,
            overflowY: !!maxHeight ? 'auto' : 'initial',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

export default NestedContentComponent
